import React from 'react';
import { X, Check, Crown } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function Comparacion() {
  const sinPack = ['Solo el material técnico y táctico base', 'Sin guía para elegir tus botines correctos', 'Sin herramientas para la presión del partido', 'Te quedás sin contenido al terminar los 30 días'];
  const conPack = ['El sistema completo del jugador zurdo', 'Sabés exactamente qué botines usar para tu pierna zurda', 'Técnicas mentales para rendir bajo presión', 'Plan de 60 días para seguir creciendo'];
  return <section className="py-16 bg-white relative" data-id="element-54">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-55">
        <FadeIn data-id="element-56">
          <div className="text-center mb-10" data-id="element-57">
            <h3 className="font-display text-celeste font-bold tracking-widest uppercase mb-2" data-id="element-58">
              EXCLUSIVO PACK PRO ÉLITE
            </h3>
            <h2 className="font-display text-3xl md:text-4xl font-black uppercase mb-3 text-navy" data-id="element-59">
              Qué vas a obtener con el{' '}
              <span className="text-celeste" data-id="element-60">Pack Pro Élite</span>
            </h2>
            <p className="text-gray-600 max-w-xl mx-auto" data-id="element-61">
              La diferencia entre tener el pack base y tener el sistema completo
              del zurdo
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-0 rounded-2xl overflow-hidden shadow-xl border border-gray-200" data-id="element-62">
          {/* Sin Pack Pro Élite */}
          <FadeIn direction="right" data-id="element-63">
            <div className="bg-lightbg p-8 h-full border-b md:border-b-0 md:border-r border-gray-200" data-id="element-64">
              <h3 className="font-display text-xl font-bold text-gray-500 mb-6 uppercase text-center" data-id="element-65">
                Sin Pack Pro Élite
              </h3>
              <ul className="space-y-5" data-id="element-66">
                {sinPack.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-600 text-sm" data-id="element-67">
                    <X className="w-5 h-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-68" />
                    <span data-id="element-69">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Con Pack Pro Élite */}
          <FadeIn direction="left" delay={0.15} data-id="element-70">
            <div className="relative bg-navy p-8 h-full overflow-hidden" data-id="element-71">
              <div className="absolute top-0 right-0 w-48 h-48 bg-celeste/10 blur-[80px] rounded-full pointer-events-none" data-id="element-72"></div>

              {/* Recommended badge */}
              <div className="flex justify-center mb-6 relative z-10" data-id="element-73">
                <span className="inline-flex items-center gap-1.5 bg-gold text-navy text-xs font-black uppercase tracking-wide px-4 py-1.5 rounded-full shadow-lg" data-id="element-74">
                  <Crown className="w-4 h-4" data-id="element-75" /> Recomendado
                </span>
              </div>

              <h3 className="font-display text-xl font-bold text-white mb-6 uppercase text-center relative z-10" data-id="element-76">
                Con Pack Pro Élite
              </h3>
              <ul className="space-y-5 relative z-10" data-id="element-77">
                {conPack.map((item, idx) => <li key={idx} className="flex items-start gap-3 text-white text-sm font-bold" data-id="element-78">
                    <span className="bg-celeste/20 rounded-full p-0.5 flex-shrink-0 mt-0.5" data-id="element-79">
                      <Check className="w-4 h-4 text-celeste" data-id="element-80" />
                    </span>
                    <span data-id="element-81">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}